import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RolesService} from '../roles.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-rights-roles-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

    public _activeRole = '';
    @Output() notify: EventEmitter<any> = new EventEmitter<any>();

    public roles: Array<any> = [];
    private loading = false;
    constructor(
        private rolesService: RolesService,
        private toastr: ToastrService
    ) { }

    @Input() set activeRole(value: string) {
        if (this._activeRole !== value && value != null) {
            this.onChange(value);
        }
        this._activeRole = value;
    }

    get activeRole(): string {
        return this._activeRole;
    }

    ngOnInit() {
        this.loading = true;
        this.rolesService.getAll(null).subscribe(result => {
                this.roles = result.data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                window.dispatchEvent(new Event('resize'));
                this.toastr.error('Request to get roles timed out.', 'Service Error', {
                    timeOut: 3000,
                });
            })
    }

    onChange(value) {
        this._activeRole = value;
        this.notify.emit(value);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/rights/roles/select/select.component.ts